<template>
  <v-card
    v-if="model"
    :data-expanded="expanded"
    data-test-id="card"
    density="compact"
    draggable="false"
    elevation="2"
    :height="expanded ? (xs ? '100%' : '100%') : undefined"
    :max-height="xs ? '100%' : maxHeight"
    :max-width="xs ? '100%' : maxWidth"
    rounded="lg"
    :width="expanded ? (xs ? '100%' : maxWidth) : undefined"
    @dragover.prevent.stop
    @drop.prevent.stop
  >
    <v-toolbar
      class="tasks-card-toolbar cursor-pointer"
      density="compact"
      @click.stop="expanded = !expanded"
    >
      <template v-if="$slots.prepend" #prepend>
        <slot name="prepend"></slot>
      </template>
      <template v-if="$slots.title || title" #title>
        <slot name="title">
          <span
            class="text-body-large font-weight-thin"
            data-test-id="card-title"
          >
            {{ title }}
          </span>
        </slot>
      </template>
      <template #append>
        <slot name="append">
          <v-btn
            :data-test-id="expanded ? 'collapse' : 'expand'"
            :icon="expanded ? 'fas fa-chevron-down' : 'fas fa-chevron-up'"
            size="small"
            slim
            v-bind="btnExpandProps"
            @click.stop="emit('click:expanded')"
          ></v-btn>
          <v-btn
            class="mr-1"
            data-test-id="close"
            icon="$close"
            size="small"
            slim
            v-bind="btnCloseProps"
            @click.stop="emit('click:close')"
          ></v-btn>
        </slot>
      </template>
    </v-toolbar>
    <v-expand-transition mode="out-in">
      <v-card-text v-show="expanded" ref="cardTextRef" class="pa-0 h-100">
        <slot name="content"></slot>
      </v-card-text>
    </v-expand-transition>

    <template #loader>
      <slot name="loader"></slot>
    </template>
  </v-card>
</template>

<script lang="ts" setup>
import { useDisplay } from 'vuetify'
import { VBtn } from 'vuetify/components'
import type { VBtnProps } from '@/types/vuetify-components.ts'

defineProps({
  title: {
    type: String,
    default: undefined,
  },
  maxWidth: {
    type: [String, Number],
    default: 350,
  },
  maxHeight: {
    type: [String, Number],
    default: 330,
  },
  btnCloseProps: {
    type: Object as PropType<VBtnProps>,
    default: undefined,
  },
  btnExpandProps: {
    type: Object as PropType<VBtnProps>,
    default: undefined,
  },
})

const model = defineModel({ type: Boolean, default: false })
const expanded = defineModel('expanded', { type: Boolean, default: false })

const emit = defineEmits(['click:close', 'click:expanded'])

const { xs } = useDisplay()
</script>
<style lang="scss" scoped>
:deep(.v-toolbar__content > .v-toolbar-title) {
  margin-inline-start: 12px;
}
</style>
